<template>
  <!-- 站点信息 -->
  <div>
    <div class="btn-group">
      <el-button @click="onExportSite" class="mr8" size="mini" type="primary"
        v-show="checkUserAuth(64, 63) && isAggregation" >导出</el-button
      >
      <el-radio-group
        @change="onSiteType"
        class="mr8"
        size="mini"
        v-model="siteType"
      >
        <el-radio-button label="时"></el-radio-button>
        <el-radio-button label="日"></el-radio-button>
        <el-radio-button label="月"></el-radio-button>
      </el-radio-group>
      <el-date-picker
        :clearable="false"
        class="datestyle"
        size="mini"
        v-model="siteRankAllTime"
        @change="onSiteRankAllTime"
        :type="
          siteType === '时' ? 'datetime' : siteType === '日' ? 'date' : 'month'
        "
        popper-class="datestyle2"
        placeholder="选择日期时间"
        :format="
          siteType === '时'
            ? 'yyyy-MM-dd HH'
            : siteType === '日'
            ? 'yyyy-MM-dd'
            : 'yyyy-MM'
        "
        default-time="12"
      >
      </el-date-picker>
    </div>
    <div  v-show="checkUserAuth(64, 59)">
      <w-table
        v-loading.body="tableLoading"
        :data-list="tableData"
        :columns="staticData[typeName]"
        :bPagination="false"
        :height="524"
        :renderHeaderByRentNum="renderHeaderByRentNum"
        :renderHeaderByReturnNum="renderHeaderByReturnNum"
      >
        <template slot-scope="props" slot="cell">
          <span v-if="props.column.label === '排名'">
            {{ props.index + 1 }}
          </span>
          <span
            v-else-if="props.column.label === '站点名称'"
            @click="jjSearch(props.row)"
            class="green1 pointer"
          >
            {{ props.row["siteName"] }}
          </span>
          <span v-else>{{ props.row[props.column.property] }}</span>
        </template>
      </w-table>
      <div v-show="!checkUserAuth(3, 16)">您的账户没有权限查看此内容！</div>
    </div>
  </div>
</template>

<script>
import WTable from "@/components/Table/index.vue";
import Api from "@/api";
import staticData from "./staticData.js";
import { mapGetters } from "vuex";

export default {
  components: {
    WTable,
  },
  props: ["typeName", "currentData"],
  data() {
    return {
      siteType: "日",
      actionOrder: 0, // 0-租车，1-还车
      siteRankAllTime: new Date(),
      width: "50%",
      tableLoading: false,
      tableData: null,
    };
  },
  computed: {
    // vue-animate-number
    ...mapGetters(["userSelectAddressData",'user']),
    isAggregation() {
      //是否是非复合区下的实体区
      return (
        (this.aggregation == 0 && this.aggregationId == "") ||
        (this.aggregation == 1 && this.aggregationId)
      );
    },
    staticData() {
      return staticData;
    },
    aggregationId() {
      // 实体区的复合区Id
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregationId
        : undefined;
    },
    aggregation() {
      // 0 - 实体区
      return this.userSelectAddressData
        ? this.userSelectAddressData.aggregation
        : undefined;
    },
  },
  created() {
    this.siteRankAll(true);
  },
  methods: {
    onSiteType() {
      this.onSiteRankAllTime();
    },
    onSiteRankAllTime() {
      if (!this.siteRankAllTime) {
        this.siteRankAll(true);
      } else {
        this.siteRankAll();
      }
    },
    getTodayTime(date) {
      const day2 = date ? new Date(date) : new Date();
      day2.setTime(day2.getTime());
      return (
        day2.getFullYear() +
        "-" +
        (day2.getMonth() < 9
          ? "0" + (day2.getMonth() + 1)
          : day2.getMonth() + 1) +
        "-" +
        (day2.getDate() < 10 ? "0" + day2.getDate() : day2.getDate()) +
        "-" +
        day2.getHours() +
        "-" +
        day2.getMinutes()
      );
    },
    getSiteParams(data) {
      const vm = this;
      const t = data ? vm.getTodayTime(data) : vm.getTodayTime();
      // console.log(11111, t, data)
      const format = t.split("-");
      return format;
    },
    // 排名
    siteRankAll(type) {
      const vm = this;
      vm.tableLoading = true;
      const format = vm.getSiteParams(vm.siteRankAllTime);
      const params = {
        selfAreaId: vm.currentData.selfAreaId, // vm.selfAreaIdOrAggregationId,
        year: format[0],
        actionOrder: vm.actionOrder,
      };
      if (vm.siteType === "时") {
        params.month = format[1];
        params.day = format[2];
        // 默认不给时间
        if (!type) {
          params.hour = format[3];
        }
      }
      if (vm.siteType === "日") {
        params.month = format[1];
        params.day = format[2];
      }
      if (vm.siteType === "月") {
        params.month = format[1];
      }
      Api.siteRankAll(params)
        .then((res) => {
          if (res.code === 200) {
            vm.tableData = res.data;
            vm.total = res.data.length;
          } else {
            vm.$message.warning(res.message);
          }
          vm.tableLoading = false;
        })
        .catch((err) => {
          console.log(err);
          vm.tableLoading = false;
        });
    },
    // 租车
    renderHeaderByRentNum(h, { column }) {
      return h("div", [
        h(
          "p",
          {
            style: this.getStyleByRentNum(),
            on: {
              click: this.onRenderHeaderByRentNum,
            },
          },
          column.label
        ),
      ]);
    },
    getStyleByRentNum() {
      if (this.actionOrder === 0) {
        return "color: #00DADA ; cursor: pointer;";
      } else if (this.actionOrder === 1) {
        return "cursor: pointer;";
      }
    },
    // 还车
    renderHeaderByReturnNum(h, { column }) {
      return h("div", [
        h(
          "p",
          {
            style: this.getStyleByReturnNum(),
            on: {
              click: this.onRenderHeaderByRentNum,
            },
          },
          column.label
        ),
      ]);
    },
    getStyleByReturnNum() {
      if (this.actionOrder === 1) {
        return "color: #00DADA ; cursor: pointer;";
      } else if (this.actionOrder === 0) {
        return "cursor: pointer;";
      }
    },
    onRenderHeaderByRentNum() {
      this.actionOrder = this.actionOrder === 0 ? 1 : 0;
      if (!this.siteRankAllTime) {
        this.siteRankAll(true);
      } else {
        this.siteRankAll();
      }
    },
    jjSearch(item) {
      const vm = this;
      if (item.siteId) {
        this.$emit('jjSearch',item)
      } else {
        vm.$message.warning("该条数据存在问题，没有车辆编号！");
      }
    },
    // 排名下载
    onExportSite() {
      const vm = this;
      const format = vm.getSiteParams(vm.siteRankAllTime);
      const params = {
        selfAreaId: vm.currentData.selfAreaId,
        year: format[0],
        actionOrder: vm.actionOrder,
      };
      if (vm.siteType === "时") {
        params.month = format[1];
        params.day = format[2];
        params.hour = format[3];
      }
      if (vm.siteType === "日") {
        params.month = format[1];
        params.day = format[2];
      }
      if (vm.siteType === "月") {
        params.month = format[1];
      }
      Api.siteRankAllOut(params).then((res) => {
        vm.$message({
          type: "success",
          message: "数据导出成功！",
        });
        const content = res;
        const blob = new Blob([content]);
        const fileName = "站点排名分析.xls";
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mr8 {
  margin-right: 8px;
}
.btn-group {
  text-align: right;
  margin-bottom: 16px;
}

.green1 {
  color: #00dada;
}
.pointer {
  cursor: pointer;
}
/deep/.el-table .el-table__cell.is-center {
  border-bottom-color: #0c3444 !important;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #618e8e !important
}
</style>
